import SolsticeForm from './SolsticeForm.js';

export default SolsticeForm;
